<template>
  <footer class="bg-gray-900 text-white py-16 px-4">
    <div class="max-w-6xl mx-auto">
      <!-- Footer Grid -->
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
        <!-- Brand Section -->
        <div class="md:col-span-1">
          <router-link to="/" class="inline-block mb-4">
            <img :src="require('@/assets/logo.png')" class="h-[40px]" alt="MINE ITS Logo" />
          </router-link>
          <p class="text-gray-400 text-sm leading-relaxed">
            A global energy player and expert operator in infrastructure technology solutions.
          </p>
        </div>

        <!-- Quick Links -->
        <div>
          <h4 class="text-white font-bold mb-4">Quick Links</h4>
          <ul class="space-y-2">
            <li><router-link to="/" class="text-gray-400 hover:text-red-600 transition">Home</router-link></li>
            <li><router-link to="/about" class="text-gray-400 hover:text-red-600 transition">About</router-link></li>
            <li><router-link to="/contact" class="text-gray-400 hover:text-red-600 transition">Contact</router-link></li>
          </ul>
        </div>

        <!-- Services -->
        <div>
          <h4 class="text-white font-bold mb-4">Services</h4>
          <ul class="space-y-2">
            <li v-for="service in data.services.list" :key="'footer_'+service.id"><a :href="'/services/'+service.title.replace(/\s+/g, '-').toLowerCase()" class="text-gray-400 hover:text-red-600 transition text-sm">{{ service.title }}</a></li>
          </ul>
        </div>

        <!-- Contact Info -->
        <div>
          <h4 class="text-white font-bold mb-4">Contact Us</h4>
          <div class="space-y-3 text-sm">
            <div>
              <p class="text-gray-400 mb-1">Malaysia | Singapore</p>
            </div>
            <div>
              <p class="text-gray-400 mb-1">Sales Inquiries</p>
              <a href="mailto:sales@mineits.com" class="text-gray-300 hover:text-red-600 transition">sales@mineits.com</a>
            </div>
            <div>
              <p class="text-gray-400 mb-1">Support</p>
              <a href="mailto:support@mineits.com" class="text-gray-300 hover:text-red-600 transition break-all">support@mineits.com</a>
            </div>
          </div>
        </div>
      </div>

      <!-- Divider -->
      <div class="border-t border-gray-700 pt-8 mt-8">
        <div class="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <p class="text-gray-400 text-sm mb-4 md:mb-0">© 2026 MINE ITS. All rights reserved.</p>
          <p class="text-gray-400 text-sm">A global energy player and expert operator</p>
        </div>
      </div>
    </div>
  </footer>
</template>



<script>
import homeData from '@/data/home.json'

export default {
  name: 'HomePage',
  data() {
    return {
      data: homeData,
    }
  },
}
</script>